import { ReactNode } from 'react';

export enum OnboardingSteps {
  WELCOME = 1,
  DASHBOARD,
  DIAGNOSTIC_CARDS,
  OVERVIEW,
  INFO_PANEL,
  EXIT,
  FINISH,
}

export type OnboardingStepData = {
  className: string;
  position: 'top' | 'bottom' | 'left' | 'bottom-right';
  padding: number;
  element: ReactNode;
};
